import React from 'react';
import CertificateVerification from '../../features/certificates/components/CertificateVerification';

export default function CertificateVerificationRoute() {
  return <CertificateVerification />;
}
